import React from 'react';
import { DeliveryInfo } from '../orderDetailsTypes';
import styles from './DeliveryInfoCard.module.css';

interface DeliveryInfoCardProps {
  info: DeliveryInfo;
}

export const DeliveryInfoCard: React.FC<DeliveryInfoCardProps> = ({ info }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>📦 Delivery Information</h3>
      <div className={styles.row}>
        <span className={styles.label}>Expected Date</span>
        <span className={styles.value}>{info.expectedDate}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Delivery Window</span>
        <span className={styles.value}>{info.deliveryWindow}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Distance</span>
        <span className={styles.value}>{info.distance}</span>
      </div>
    </div>
  );
};
